import { Loading } from './components/loading';

export const RebalanceLoadingContainer = Loading;
